import { Fragment } from 'react'
import type { RichText } from '@/domain/workout'

/**
 * Pinta texto con partes en negrita sin recurrir a HTML dentro de los datos:
 * el contenido del reto se mantiene como datos puros y traducibles.
 */
export function Rich({ parts }: { parts: readonly RichText[] }) {
  return (
    <>
      {parts.map((part, index) => (
        <Fragment key={index}>{part.strong ? <b>{part.text}</b> : part.text}</Fragment>
      ))}
    </>
  )
}
